import React, { useState, useEffect, useRef } from 'react';
import { Save, Download, Plus, X, Search, Loader2 } from 'lucide-react';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import config from '../config/config';
import DynamicNav from "../config/dynamicNav";
import { useNavigate, useParams } from 'react-router-dom';

export default function ExamResultInterface({ iidaupi }) {
  const navigate = useNavigate();
  const { idaupi } = useParams();
  const [username, setUser] = useState('');
  const [closingDate, setClosingDate] = useState('');
  const [admission, setAdmission] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [termName, setTermName] = useState('');
  const [selectedClass, setSelectedClass] = useState('PG');
  const [useraccount_type, setUserAccount] = useState('');
  const [terms, setTerms] = useState([]);
  const [termId, setTerm] = useState('all');
  const [performanceCategory, setPerformanceCategory] = useState('BE');
  const [validationErrors, setValidationErrors] = useState([]);
  const [formData, setFormData] = useState({
    schoolName: '',
    learnerName: '',
    idaupi: '',
    classTeacher: '',
    termId: '',
    teacherId: '',
    term: 'TERM 3',
    year: new Date().getFullYear(),
    totalDaysOpener: 0,
    totalDaysMid: 0,
    totalDaysEnd: 0,
    totalDaysAbsent: 0,
    totalDaysOpener2: 0,
    totalDaysMid2: 0,
    totalDaysEnd2: 0,
    totalDaysPresent: 0,
    meetingExpectation: '50-59%',
    exceedingExpectation: '60-100%',
    approachingExpectation: '40-49%',
    belowExpectation: '0-39%',
    reasonStrand: '',
    lastStrand: '',
    subStrand: '',
    totalStrands: '',
    totalNotStrands: '',
    openingDate: '',
    closingDate: closingDate || '',
  });

  const classGrades = [
    { value: 'PG', label: 'Playgroup (2-3 years)' },
    { value: 'PP1', label: 'Pre-primary 1 (4-5 years)' },
    { value: 'PP2', label: 'Pre-primary 2 (4-5 years)' },
    { value: 'G1', label: 'Grade 1 (6-8 years)' },
    { value: 'G2', label: 'Grade 2 (6-8 years)' },
    { value: 'G3', label: 'Grade 3 (6-8 years)' },
    { value: 'G4', label: 'Grade 4 (9 years)' },
    { value: 'G5', label: 'Grade 5 (9 years)' },
    { value: 'G6', label: 'Grade 6 (11 years)' },
  ];

  const setSelectedClassMain = (classD) => {
    setSelectedClass(classD);
    fetchStudents(classD);
    setActivitiesActual(classD);
  };

  const setTermMain = (termD) => {
    setTerm(termD);
    setTimeout(function(){
         fetchExamResult(idaupi);
    },3000);
  };

  const fetchStudents = async (selectedClass = '') => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullstudents/${selectedClass}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setFilteredStudents([]);
      setStudents(res.data.students);
      setUser(res.data.user);
      setUserAccount(res.data.account);
    } catch (err) {
      console.error('Error fetching students:', err);
    }
  };

  const [students, setStudents] = useState([]);
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);

  const [activitiesGroup3, setActivities3] = useState([
    { name: 'Mathematics Activities', scores: {} },
    { name: 'English Activities', scores: {} },
    { name: 'Indigenous Language Activities', scores: {} },
    { name: 'Shughuli Za Kiswahili', scores: {} },
    { name: 'Environmental Activities', scores: {} },
    { name: 'Religious Activities(CRE/IRE/HRE)', scores: {} },
    { name: 'Creative Activities', scores: {} },
  ]);

  const [activitiesGroup2, setActivities2] = useState([
    { name: 'Mathematics Activities', scores: {} },
    { name: 'Language Activities', scores: {} },
    { name: 'Environmental Activities', scores: {} },
    { name: 'Religious Activities(CRE/IRE/HRE)', scores: {} },
    { name: 'Creative Activities', scores: {} },
  ]);

  const [activitiesGroup1, setActivities1] = useState([
    { name: 'Mathematics Activities', scores: {} },
    { name: 'English Activities', scores: {} },
    { name: 'Kiswahili Activities / KSL', scores: {} },
    { name: 'Science & Technology Activities', scores: {} },
    { name: 'Creative Arts Activities', scores: {} },
    { name: 'Agri-Nutrition Activities', scores: {} },
    { name: 'Social Studies Activities', scores: {} },
    { name: 'Religious Education Activities(CRE/IRE/HRE)', scores: {} },
  ]);

  const [activities, setActivities] = useState([]);

  const setActivitiesActual = (selectedClass = 'PG') => {
    if (['PG', 'PP1', 'PP2'].includes(selectedClass)) {
      setActivities(activitiesGroup2);
    } else if (['G1', 'G2', 'G3'].includes(selectedClass)) {
      setActivities(activitiesGroup3);
    } else if (['G4', 'G5', 'G6'].includes(selectedClass)) {
      setActivities(activitiesGroup1);
    } else {
      setActivities(activitiesGroup3); // Default to G1-G3 activities
    }
  };

  const [remarks, setRemarks] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const contentRef = useRef(null);

  const assessmentTypes = [
    { period: 'Opener', columns: ['EE(4)', 'ME(3)', 'AE(2)', 'BE(1)', 'NA(0)'] },
    { period: 'Mid Term', columns: ['EE(4)', 'ME(3)', 'AE(2)', 'BE(1)', 'NA(0)'] },
    { period: 'End Term', columns: ['EE(4)', 'ME(3)', 'AE(2)', 'BE(1)', 'NA(0)'] },
  ];

  // Helper function to normalize scores
  const normalizeScores = (scores, period) => {
    const normalized = {
      'EE(4)': scores['EE(4)'] || (period === 'Mid Term' ? scores['EE(6)'] : '') || '',
      'ME(3)': scores['ME(3)'] || (period === 'Mid Term' ? scores['ME(4)'] : '') || '',
      'AE(2)': scores['AE(2)'] || '',
      'BE(1)': scores['BE(1)'] || '',
      'NA(0)': scores['NA(0)'] || '',
    };
    return normalized;
  };

  const fetchTerms = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullterms`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setTerms(res.data.terms || res.data || []);
      setTerm(res.data.termId || 'all');
      setClosingDate(res.data.closingDate || 'all');
      setTermName(res.data.termName || '');
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
  };

  const calculatePerformance = () => {
    const scoreMap = { 'EE': 4, 'ME': 3, 'AE': 2, 'BE': 1, 'NA': 0 };

    const allScores = activities
      .map(activity =>
        [
          ...Object.values(activity.scores['Opener'] || {}),
          ...Object.values(activity.scores['Mid Term'] || {}),
          ...Object.values(activity.scores['End Term'] || {}),
        ].map(score => scoreMap[score] || 0)
      )
      .flat()
      .filter(score => score >= 0); // Include NA(0) in calculations

    const overallAvg = allScores.length ? allScores.reduce((a, b) => a + b, 0) / allScores.length : 0;
    let performanceCategory = 'BE';
    if (overallAvg >= 3.5) performanceCategory = 'EE';
    else if (overallAvg >= 2.5) performanceCategory = 'ME';
    else if (overallAvg >= 1.5) performanceCategory = 'AE';

    setPerformanceCategory(performanceCategory);

    setFormData(prev => ({
      ...prev,
      exceedingExpectation: '60-100%',
      meetingExpectation: '50-59%',
      approachingExpectation: '40-49%',
      belowExpectation: '0-39%',
    }));
  };

  useEffect(() => {
    fetchStudents();
    fetchTerms();
    setActivitiesActual();
    const effectiveIdaupi = idaupi || '101K';
    if (effectiveIdaupi) {
      fetchExamResult(effectiveIdaupi);
    }
  }, [idaupi]);

  useEffect(() => {
    calculatePerformance();
  }, [activities]);

  const fetchExamResult = async (idaupi) => {
    setLoading(true);
    try {
      setAdmission(idaupi);
      const response = await axios.get(`${config.API_URL}/api/exam-results/${idaupi}/${termId}`);
      const { data } = response;
      const studentClass = data.selectedClass || 'G2';
      setSelectedClass(data.selectedClass);

      const currentActivities = ['PG', 'PP1', 'PP2'].includes(studentClass)
        ? activitiesGroup2
        : ['G1', 'G2', 'G3'].includes(studentClass)
        ? activitiesGroup3
        : activitiesGroup1;

      // Map scores with normalization
      const newActivities = currentActivities.map(activity => {
        const relatedScores = data.assessment_scores
          .filter(score => {
            const scoreActivityName = score.activity_name?.trim().toLowerCase();
            const activityName = activity.name.trim().toLowerCase();
            const isValidActivity = currentActivities.some(a => a.name.trim().toLowerCase() === scoreActivityName);
            const isExactMatch = scoreActivityName === activityName;
            if (!isValidActivity && score.activity_name) {
              console.warn(`Score for '${score.activity_name}' ignored: not in ${studentClass} activities`);
            }
            return isExactMatch && isValidActivity;
          })
          .map(score => ({
            period: score.period,
            scores: normalizeScores(JSON.parse(score.scores) || {}, score.period),
          }))
          .reduce((acc, scoreData) => {
            acc[scoreData.period] = scoreData.scores;
            return acc;
          }, {});
        return { ...activity, scores: relatedScores };
      });

      console.log('New Activities:', JSON.stringify(newActivities, null, 2));
      setActivities(newActivities);

      const initialFormData = {
        schoolName: data.school_name || '',
        learnerName: data.learner_name || '',
        idaupi: data.idaupi || '',
        classTeacher: data.class_teacher || '',
        termId: data.termId || '',
        teacherId: data.teacherId || '',
        term: data.term || 'TERM 3',
        year: data.year || new Date().getFullYear(),
        totalDaysOpener: data.total_days_opener || 0,
        totalDaysMid: data.total_days_mid || 0,
        totalDaysEnd: data.total_days_end || 0,
        totalDaysAbsent: data.total_days_absent || 0,
        totalDaysOpener2: data.total_days_opener_present || 0,
        totalDaysMid2: data.total_days_mid_present || 0,
        totalDaysEnd2: data.total_days_end_present || 0,
        totalDaysPresent: data.total_days_present || 0,
        meetingExpectation: data.meeting_expectation || '50-59%',
        exceedingExpectation: data.exceeding_expectation || '60-100%',
        approachingExpectation: data.approaching_expectation || '40-49%',
        belowExpectation: data.below_expectation || '0-39%',
        reasonStrand: data.reason_strand || '',
        lastStrand: data.last_strand || '',
        subStrand: data.sub_strand || '',
        totalStrands: data.total_strands || '',
        totalNotStrands: data.total_not_strands || '',
        openingDate: data.opening_date || '',
        closingDate: data.closing_date || closingDate || '',
      };
      setFormData(initialFormData);
      setRemarks(data.remarks || '');
      setShowSearchDropdown(false);
      calculatePerformance();
    } catch (err) {
      if (idaupi !== '101K') {
        setError('Failed to fetch data: ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return decodeURIComponent(match[2]);
    return null;
  };

  const validateActivities = () => {
    const errors = [];
    const invalidFields = [];
    const periods = ['Opener', 'Mid Term', 'End Term'];

    // Determine which periods have at least one score
    const activePeriods = periods.filter(period =>
      activities.some(activity => 
        activity.scores[period] && 
        Object.values(activity.scores[period]).some(score => score && score !== '-' && score !== 'NA')
      )
    );

    if (activePeriods.length === 0) {
      errors.push('At least one period must have scores entered (excluding NA).');
      return { errors, invalidFields };
    }

    // Validate each active period
    activities.forEach((activity, actIdx) => {
      activePeriods.forEach(period => {
        const scores = activity.scores[period] || {};
        const selectedScores = Object.values(scores).filter(score => score && score !== '-').length;

        // Check if the period has exactly one score
        if (selectedScores === 0) {
          errors.push(`${activity.name} is missing a score for ${period}.`);
          invalidFields.push({ actIdx, period });
        } else if (selectedScores > 1) {
          errors.push(`${activity.name} has multiple scores for ${period}. Please select only one score.`);
          invalidFields.push({ actIdx, period });
        }
      });
    });

    return { errors, invalidFields };
  };

  const handleScoreChange = (activityIndex, period, column, value) => {
    const newActivities = [...activities];
    const currentActivity = newActivities[activityIndex];

    if (!currentActivity.scores[period]) {
      currentActivity.scores[period] = {};
    }

    if (value && value !== '-') {
      // Clear other scores in the same period to ensure only one score is selected
      Object.keys(currentActivity.scores[period]).forEach(key => {
        currentActivity.scores[period][key] = '';
      });
      currentActivity.scores[period][column] = value;
    } else {
      currentActivity.scores[period][column] = '';
      if (Object.values(currentActivity.scores[period]).every(v => !v)) {
        delete currentActivity.scores[period];
      }
    }

    setActivities(newActivities);
    setValidationErrors([]);
  };

  const handleSave = async () => {
    setLoading(true);
    setError(null);
    setValidationErrors([]);

    // Validate class teacher
    if (formData.classTeacher === '') {
      setError('Class teacher is required');
      setLoading(false);
      return;
    }

    // Validate activities
    const { errors, invalidFields } = validateActivities();
    if (errors.length > 0) {
      setValidationErrors(errors);
      setError('Please fix the highlighted fields in the Learning Activities Assessment.');
      // Highlight invalid fields
      invalidFields.forEach(({ actIdx, period }) => {
        const select = document.querySelector(`#score-${actIdx}-${period.replace(/\s/g, '-')}`);
        if (select) {
          select.classList.add('error-highlight');
          setTimeout(() => select.classList.remove('error-highlight'), 3000);
        }
      });
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, {
        withCredentials: true,
      });
      const xsrfToken = getCookie('XSRF-TOKEN');
      if (!xsrfToken) {
        throw new Error('CSRF token not found');
      }

      // Normalize activities scores before saving
      const normalizedActivities = activities.map(activity => ({
        ...activity,
        scores: Object.fromEntries(
          Object.entries(activity.scores).map(([period, scores]) => [
            period,
            normalizeScores(scores, period),
          ])
        ),
      }));

      const payload = {
        formData: {
          schoolName: formData.schoolName,
          learnerName: formData.learnerName,
          idaupi: formData.idaupi,
          classTeacher: formData.classTeacher,
          termId: formData.termId,
          teacherId: formData.teacherId,
          term: formData.term,
          year: formData.year,
          totalDaysOpener: formData.totalDaysOpener,
          totalDaysMid: formData.totalDaysMid,
          totalDaysEnd: formData.totalDaysEnd,
          totalDaysAbsent: formData.totalDaysAbsent,
          totalDaysOpener2: formData.totalDaysOpener2,
          totalDaysMid2: formData.totalDaysMid2,
          totalDaysEnd2: formData.totalDaysEnd2,
          totalDaysPresent: formData.totalDaysPresent,
          reasonStrand: formData.reasonStrand,
          lastStrand: formData.lastStrand,
          subStrand: formData.subStrand,
          totalStrands: formData.totalStrands,
          totalNotStrands: formData.totalNotStrands,
          openingDate: formData.openingDate,
          closingDate: formData.closingDate,
          meetingExpectation: performanceCategory === 'ME' ? '50-59%' : null,
          exceedingExpectation: performanceCategory === 'EE' ? '60-100%' : null,
          approachingExpectation: performanceCategory === 'AE' ? '40-49%' : null,
          belowExpectation: performanceCategory === 'BE' ? '0-39%' : null,
        },
        activities: normalizedActivities,
        remarks,
      };

      console.log('Save Payload:', JSON.stringify(payload, null, 2));

      const response = await axios.post(
        `${config.API_URL}/api/saveExams`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-XSRF-TOKEN': xsrfToken,
          },
        }
      );
      alert(response.data.message);
    } catch (err) {
      setError('Failed to save data: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async () => {
    const token = localStorage.getItem('token');
    window.open(`${config.API_URL}/downloadResults/${admission}/${token}`);
    return;
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setShowSearchDropdown(true);
    const filtered = students.filter(
      s =>
        s.name.toLowerCase().includes(query.toLowerCase()) ||
        s.admission_number.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredStudents(filtered);
  };

  const dismissError = () => {
    setValidationErrors([]);
    setError(null);
    document.querySelectorAll('.error-highlight').forEach(el => el.classList.remove('error-highlight'));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 p-4 md:p-8">
      <div className="max-w-7xl mx-auto" ref={contentRef}>
        {loading &&  <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
          <div className="flex flex-col items-center gap-3">
            <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
            <p className="text-base text-gray-600 font-medium">Loading grading module...</p>
          </div>
        </div>}
        {error && (
          <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg flex justify-between items-center animate-slide-in">
            <div>
              <p className="font-semibold">Validation Error</p>
              <ul className="list-disc pl-5">
                {validationErrors.map((err, idx) => (
                  <li key={idx}>{err}</li>
                ))}
              </ul>
            </div>
            <button onClick={dismissError} className="text-red-700 hover:text-red-900">
              <X size={18} />
            </button>
          </div>
        )}
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <DynamicNav/>
          <div className="text-center mb-6">
            <h1 className="text-2xl font-light text-slate-800 mb-2">Ministry of Education</h1>
            <p className="text-sm text-slate-600">State Department of Early Learning and Basic Education</p>
            <p className="text-xs text-slate-500 mt-1">School {termName || 'Term'} Summative Report for Early Years Education</p>
          </div>

          <div className="flex justify-between items-center mb-3">
            <h2 className="text-xl font-medium text-slate-800">{selectedClass} Termly Exam Result Summary</h2>
            <div className="flex gap-3">
              <button
                onClick={handleExport}
                disabled={loading}
                className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors disabled:opacity-50"
              >
                <Download size={18} />
                Export
              </button>
            </div>
          </div>
        </div>
        <br/>
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 ">
          <center>
            <div className="hidden md:block relative mb-3 mx-6 d-flex">
              <hr />
              <div className="mr-3">
                <select
                  value={selectedClass}
                  onChange={e => setSelectedClassMain(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
                >
                  <option value="">Filter By Class</option>
                  <option value="">View From All Classes</option>
                  {classGrades.map(s => (
                    <option key={s.value} value={s.value}>
                      {s.label}
                    </option>
                  ))}
                </select>
              </div>

              <input
                type="text"
                style={{ border: '2px solid black' }}
                value={searchQuery}
                onClick={e => {
                  setShowSearchDropdown(true);
                  handleSearch('');
                }}
                onChange={e => handleSearch(e.target.value)}
                placeholder="Search Students..."
                className="w-full mr-3 pl-10 pr-4 py-2.5 rounded-xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm transition-all"
              />
              {showSearchDropdown && (
                <div className="absolute z-10 bg-white border border-gray-100 rounded-xl shadow-lg mt-12 max-h-60 overflow-auto w-full">
                  <div className="p-2">
                    <h4 className="text-xs font-medium text-gray-500 mb-1 px-2">RESULTS</h4>
                    {filteredStudents.map(student => (
                      <div
                        key={student.id}
                        onClick={() => fetchExamResult(`${student.admission_number}`)}
                        className="p-2 hover:bg-indigo-50 rounded-lg cursor-pointer text-sm flex items-center"
                      >
                        <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 mr-3">
                          {student.name.charAt(0)}
                        </div>
                        <div>
                          <p className="font-medium text-gray-800">{student.name}</p>
                        </div>
                      </div>
                    ))}
                    {filteredStudents.length === 0 && (
                      <div className="p-2 text-gray-500 text-sm">No students found.</div>
                    )}
                  </div>
                </div>
              )}

              <div className="mr-3">
                <select
                  value={termId}
                  onMouseOver={e => setTermMain(e.target.value)}
                  onClick={e => setTermMain(e.target.value)}
                  onChange={e => setTermMain(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
                >
                  <option value="0">Filter By Term</option>
                  <option value="0">Select Term</option>
                  {terms.map(term => (
                    <option key={term.id} value={term.id}>
                      {term.term}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </center>
        </div>
        <br />
        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Student Information</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Name of School</label>
              <input
                type="text"
                name="schoolName"
                value={formData.schoolName}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                placeholder="Enter school name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Name of the Learner</label>
              <input
                type="text"
                name="learnerName"
                value={formData.learnerName}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                placeholder="Enter learner name"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">IDAUPI</label>
              <input
                type="text"
                name="idaupi"
                value={formData.idaupi}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                placeholder="Enter IDAUPI"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Class Teacher</label>
              <input
                type="text"
                name="classTeacher"
                value={formData.classTeacher}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
                placeholder="Enter teacher name"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Enrollment & Attendance</h3>
          <div className="grid grid-cols-2 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Term</label>
              <input
                type="text"
                name="term"
                disabled
                value={formData.term}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Year</label>
              <input
                type="number"
                name="year"
                disabled
                value={formData.year}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Opener (Days Absent)</label>
              <input
                type="number"
                name="totalDaysOpener"
                value={formData.totalDaysOpener}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Mid Term (Days Absent)</label>
              <input
                type="number"
                name="totalDaysMid"
                value={formData.totalDaysMid}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">End Term (Days Absent)</label>
              <input
                type="number"
                name="totalDaysEnd"
                value={formData.totalDaysEnd}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Total Days Absent</label>
              <input
                type="number"
                name="totalDaysAbsent"
                value={formData.totalDaysAbsent}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Opener (Days Present)</label>
              <input
                type="number"
                name="totalDaysOpener2"
                value={formData.totalDaysOpener2}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Mid Term (Days Present)</label>
              <input
                type="number"
                name="totalDaysMid2"
                value={formData.totalDaysMid2}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">End Term (Days Present)</label>
              <input
                type="number"
                name="totalDaysEnd2"
                value={formData.totalDaysEnd2}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Total Days Present</label>
              <input
                type="number"
                name="totalDaysPresent"
                value={formData.totalDaysPresent}
                onChange={handleInputChange}
                className="w-full px-4 py-2.5 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent"
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Meeting Expectation Summary</h3>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Exceeding Expectation (EE)</label>
              <span
                style={
                  performanceCategory === 'EE'
                    ? { backgroundColor: 'green', color: 'white', padding: '2px 4px' }
                    : {}
                }
              >
                {formData.exceedingExpectation}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Meeting Expectation (ME)</label>
              <span
                style={
                  performanceCategory === 'ME'
                    ? { backgroundColor: 'green', color: 'white', padding: '2px 4px' }
                    : {}
                }
              >
                {formData.meetingExpectation}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Approaching Expectation (AE)</label>
              <span
                style={
                  performanceCategory === 'AE'
                    ? { backgroundColor: 'green', color: 'white', padding: '2px 4px' }
                    : {}
                }
              >
                {formData.approachingExpectation}
              </span>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">Below Expectation (BE)</label>
              <span
                style={
                  performanceCategory === 'BE'
                    ? { backgroundColor: 'green', color: 'white', padding: '2px 4px' }
                    : {}
                }
              >
                {formData.belowExpectation}
              </span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Learning Activities Assessment</h3>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-slate-200">
                  <th className="text-left py-3 px-4 font-medium text-slate-700">Learning Activities</th>
                  {assessmentTypes.map((assessment, idx) => (
                    <th
                      key={idx}
                      colSpan={assessment.columns.length}
                      className={`text-center py-3 px-2 font-medium text-slate-700 border-l border-slate-200 ${
                        idx === 0 ? 'bg-opener' : idx === 1 ? 'bg-mid-term' : 'bg-end-term'
                      }`}
                    >
                      {assessment.period}
                    </th>
                  ))}
                </tr>
                <tr className="border-b border-slate-200 bg-slate-50">
                  <th className="py-2 px-4"></th>
                  {assessmentTypes.map((assessment, idx) => (
                    <React.Fragment key={idx}>
                      {assessment.columns.map((col, colIdx) => (
                        <th
                          key={colIdx}
                          className={`text-center py-2 px-2 text-xs font-medium text-slate-600 border-l border-slate-200 ${
                            idx === 0 ? 'bg-opener' : idx === 1 ? 'bg-mid-term' : 'bg-end-term'
                          }`}
                        >
                          {col}
                        </th>
                      ))}
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              <tbody>
                {activities.map((activity, actIdx) => (
                  <tr key={actIdx} className="border-b border-slate-100 hover:bg-slate-50">
                    <td className="py-3 px-4 font-medium text-slate-700">{activity.name}</td>
                    {assessmentTypes.map((assessment, assIdx) => (
                      <React.Fragment key={assIdx}>
                        {assessment.columns.map((col, colIdx) => {
                          const period = assessment.period;
                          const currentValue = activity.scores[period]?.[col] || '';
                          const columnLabel = col.split('(')[0];
                          const hasValue = currentValue && currentValue !== '-';
                          return (
                            <td
                              key={colIdx}
                              className={`py-2 px-2 border-l border-slate-100 ${
                                assIdx === 0 ? 'bg-opener' : assIdx === 1 ? 'bg-mid-term' : 'bg-end-term'
                              }`}
                            >
                              <select
                                id={`score-${actIdx}-${period.replace(/\s/g, '-')}`}
                                value={currentValue}
                                onChange={e => handleScoreChange(actIdx, period, col, e.target.value)}
                                className={`w-[60px] px-2 py-1.5 rounded text-center border-2 ${
                                  hasValue ? 'border-gray-900' : 'border-gray-400'
                                } focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent`}
                              >
                                <option value="">{currentValue || '-'}</option>
                                {assessment.columns.map((option, optIdx) => (
                                  <option key={optIdx} value={option.split('(')[0]}>
                                    {option.split('(')[0]}
                                  </option>
                                ))}
                              </select>
                            </td>
                          );
                        })}
                      </React.Fragment>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-medium text-slate-800"></h2>
          <div className="flex gap-3">
            <button
              onClick={handleSave}
              disabled={loading}
              className="flex items-center gap-2 px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition-colors disabled:opacity-50"
            >
              <Save size={18} />
              Save
            </button>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">General Remarks</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label>Opening Date</label>
              <input
                type="date"
                style={{ border: '2px solid black' }}
                name="openingDate"
                value={formData.openingDate}
                onChange={handleInputChange}
                className="w-full mr-3 pl-10 pr-4 py-2.5 rounded-xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm transition-all"
              />
            </div>
            <div>
              <label>Closing Date</label>
              <input
                type="text"
                style={{ border: '2px solid black' }}
                name="closingDate"
                value={formData.closingDate || closingDate}
                onChange={handleInputChange}
                disabled
                className="w-full mr-3 pl-10 pr-4 py-2.5 rounded-xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm transition-all"
              />
            </div>
          </div>

          <br/>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label>Total No Of Strands Covered</label>
              <input
                type="text"
                style={{ border: '2px solid black' }}
                value={formData.totalStrands}
                name="totalStrands"
                onChange={handleInputChange}
                className="w-full mr-3 pl-10 pr-4 py-2.5 rounded-xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm transition-all"
              />
            </div>
            <div>
              <label>Last Strand</label>
              <input
                type="text"
                style={{ border: '2px solid black' }}
                value={formData.lastStrand}
                name="lastStrand"
                onChange={handleInputChange}
                className="w-full mr-3 pl-10 pr-4 py-2.5 rounded-xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm transition-all"
              />
            </div>
            <div>
              <label>Sub Strand</label>
              <input
                type="text"
                style={{ border: '2px solid black' }}
                value={formData.subStrand}
                name="subStrand"
                onChange={handleInputChange}
                className="w-full mr-3 pl-10 pr-4 py-2.5 rounded-xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm transition-all"
              />
            </div>
          </div>
          <br/>
          <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
            <div>
              <label>Strands / Sub-strands Not Covered By Learner</label>
              <input
                type="text"
                style={{ border: '2px solid black' }}
                name="totalNotStrands"
                value={formData.totalNotStrands}
                onChange={handleInputChange}
                className="w-full mr-3 pl-10 pr-4 py-2.5 rounded-xl bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm transition-all"
              />
            </div>
            <br/>
            <div>
              <label>Reason</label>
              <textarea
                name="reasonStrand"
                value={formData.reasonStrand}
                onChange={handleInputChange}
                rows="4"
                className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent resize-none"
                placeholder="Provide reason for not covering strands..."
              />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <h3 className="text-lg font-medium text-slate-800 mb-4">Facilitator's Remarks</h3>
          <textarea
            value={remarks}
            onChange={e => setRemarks(e.target.value)}
            rows="4"
            className="w-full px-4 py-3 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-transparent resize-none"
            placeholder="Based on Core Competencies, Achievements, PCI's Development and Values..."
          />
        </div>
        <div className="flex justify-between items-center mb-3">
          <h2 className="text-xl font-medium text-slate-800">{selectedClass} Termly Exam Result Summary</h2>
          <div className="flex gap-3">
            <button
              onClick={handleSave}
              disabled={loading}
              className="flex items-center gap-2 px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition-colors disabled:opacity-50"
            >
              <Save size={18} />
              Save
            </button>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 mb-6">
          <p>Facilitator's Signature: ____________________ Date: ____________________</p>
          <p>Head Teacher's Signature: ____________________ Date: ____________________</p>
          <p>Parent/Guardian's Signature: ____________________ Date: ____________________</p>
          <p>OPENING DATE: ____________________</p>
          <p>CLOSING DATE: {closingDate}</p>
          <p>NEXT TERM BEGINS ON: ____________________</p>
          <p>School Stamp & Date: ____________________</p>
        </div>
      </div>
    </div>
  );
}

const styles = `
  .bg-opener { background-color: #cde4da; }
  .bg-mid-term { background-color: #c9d6e9; }
  .bg-end-term { background-color: #f8f3f0; }
  .error-highlight {
    border: 2px solid #ef4444 !important;
    animation: pulse 0.5s ease-in-out infinite;
  }
  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.7); }
    70% { box-shadow: 0 0 0 8px rgba(239, 68, 68, 0); }
    100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
  }
  .animate-slide-in {
    animation: slideIn 0.3s ease-out;
  }
  @keyframes slideIn {
    from { transform: translateY(-20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

const styleSheet = document.createElement('style');
styleSheet.textContent = styles;
document.head.appendChild(styleSheet);